import IconContainer from '@/components/IconContainer'

export default function IconTwitter(props) {
  return (
    <IconContainer
      {...props}
      width="20"
      height="20"
      ariaLabel="Twitter Icon"
      fill="currentColor"
    >
      <path d="M0.671933 1.06262L8.10414 10.9217L0.625 18.9376H2.30825L8.85623 11.9196L14.1468 18.9376H19.875L12.0246 8.52394L18.9861 1.06262H17.3029L11.2725 7.52609L6.40012 1.06262H0.671933ZM3.14729 2.29272H5.77883L17.3993 17.7073H14.7677L3.14729 2.29272Z" />
    </IconContainer>
  )
}
